import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	id: null,
	sfapigw_host: '',
	trackingURL: '',
	baseUrl: '',
	optimizelySdkKey: '',
};

const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		setApp: (state, action) => action.payload.app,
		initialize: () => {},
		ready: () => {},
	},
});

export const { setApp, initialize, ready } = appSlice.actions;

export const APP = {
	SET: setApp.type,
	INITIALIZE: initialize.type,
	READY: ready.type,
	LOG_IMPRESSION_REQUEST: 'SSDC/APP/LOG_IMPRESSION_REQUEST',
	LOG_IMPRESSION_SUCCESS: 'SSDC/APP/LOG_IMPRESSION_SUCCESS',
	LOG_IMPRESSION_FAILURE: 'SSDC/APP/LOG_IMPRESSION_FAILURE',
};

export const initializeApp = () => (dispatch) => {
	dispatch(initialize());
};

export const appReady = () => (dispatch) => {
	dispatch(ready());
};

export default appSlice.reducer;
